// import Sidebar from "components/user/Sidebar";
// import ToolBar from "components/user/ToolBar";
// import Listing from "./Listing";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { useEffect } from "react";
// import { useAppDispatch } from "hooks/store";
// import { fetchInitialData } from "store/slices/main.slice";

// type Props = {};

// const MainPage = (props: Props) => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const [searchParams] = useSearchParams();

//   useEffect(() => {
//     if (!searchParams.get("product")) {
//       dispatch(fetchInitialData(navigate));
//     }
//   }, [searchParams]);
//   return (
//     <div className="min-h-screen">
//       <ToolBar />
//       <div className="flex h-[calc(100vh-60px)] relative">
//         <Sidebar />
//         <div className="flex-1">
//           <Listing />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MainPage;

import { useState } from "react"; // Import useState for managing the toggle state
import Sidebar from "components/user/Sidebar";
import ToolBar from "components/user/ToolBar";
import Listing from "./Listing";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { fetchInitialData } from "store/slices/main.slice";
import HorizontalMenu from "components/user/HorizontalBar";
import DeliveryTypePopup from "components/user/DeliveryTypePopUp";

const MainPage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  const handlePopupSubmit = () => {
    setIsPopupOpen(false);
  };

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { settings } = useAppSelector(({ main }) => main);
  const cartLength = useAppSelector(({ main }) => main.cart.length);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get("product")) {
      dispatch(fetchInitialData(navigate));
    }
  }, [searchParams, dispatch, navigate, cartLength]);

  useEffect(() => {
    if (cartLength === 0 && settings.ApplyTakeOutDeliveryPrice !== 0) {
      setIsPopupOpen(true);
    }
  }, [cartLength, settings.ApplyTakeOutDeliveryPrice]);
  return (
    <div className="flex-1 max-w-screen-3xl 3xl:mx-auto flex flex-col min-h-screen w-full">
      <ToolBar />
      <div className="flex flex-col flex-1 w-full">
        {settings?.menuDirection === "Left" ? (
          <div className="flex h-full">
            <Sidebar />
            <div className="flex-1 overflow-y-hidden max-h-[calc(100vh-100px)] w-full">
              <Listing />
            </div>
          </div>
        ) : (
          <div className="flex flex-col h-full flex-1">
            <HorizontalMenu />
            <div className="flex-1 overflow-y-scroll max-h-[calc(100vh-180px)]">
              <Listing />
            </div>
          </div>
        )}
        <DeliveryTypePopup
          open={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          onSubmit={handlePopupSubmit}
        />
      </div>
    </div>
  );
};

export default MainPage;
